{
  "externalShare.title": "Paylaşılan içeriği gözden geçir",
  "externalShare.description": "İçeriği gözden geçirip İçe Aktar'ı seçene kadar hesabına hiçbir şey eklenmez.",
  "externalShare.loading": "Exognitos'a paylaşılan içerik açılıyor…",
  "externalShare.loadError": "Paylaşılan içerik bu cihazda açılamadı.",
  "externalShare.preserved": "Bekleyen paylaşımın korundu; yeniden deneyebilirsin.",
  "externalShare.sharedContent": "Paylaşılan içerik",
  "externalShare.sharedTitle": "Başlık",
  "externalShare.sharedText": "Metin",
  "externalShare.sharedUrl": "URL",
  "externalShare.files": "Dosyalar",
  "externalShare.filesDescription": "Bu dosyaların tam kopyaları, yükleme kontrollerinden sonra yeni Taslağa eklenecek.",
  "externalShare.unknownFileType": "Bilinmeyen dosya türü",
  "externalShare.fileSizeBytes": "{{value}} B",
  "externalShare.fileSizeKilobytes": "{{value}} KB",
  "externalShare.fileSizeMegabytes": "{{value}} MB",
  "externalShare.filesUnavailable": "Dosya yükleme şu anda kullanılamıyor. Paylaşım bu cihazda kalacak.",
  "externalShare.progress": "{{total}} dosyanın {{completed}} tanesi eklendi.",
  "externalShare.keepForLater": "Sonraya bırak",
  "externalShare.import": "Taslak olarak içe aktar",
  "externalShare.success": "Paylaşılan içerik Taslak olarak kaydedildi",
  "externalShare.empty": "Gözden geçirilecek paylaşım yok",
  "externalShare.emptyDescription": "Başka bir uygulamadan Exognitos'a metin, bağlantı, fotoğraf veya belge paylaş.",
  "externalShare.openDrafts": "Taslakları aç",
  "externalShare.reauthorizeFiles": "Bu Android yetkilendirmesi dosya paylaşımından önce oluşturulmuş. Çıkış yapıp yeniden giriş yaptıktan sonra tekrar dene; bekleyen paylaşımın bu cihazda kalacak.",
  "externalShare.submitError": "Paylaşılan içerik içe aktarılamadı."
}
